import { useNavigate } from "react-router";
import { useState } from "react";
import { ModalComp } from "../../components";
import { useAppDispatch, useAppSelector } from "../../redux/Hooks/Hook";
import { AllSessionList } from "../../redux/Slice/Sessions/SessionsListSlice";
import { DeleteSession } from "../../utilities/api/session";
import { toast } from "react-toastify";

const ArchiveSession = ({
  archive,
  setArchive,
  id,
}: any) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [isDeleting, setIsDeleting] = useState(false);
  const { SelectedFacility = "" } = useAppSelector(
    (state) => state.facilityList
  );

  const handleDelete = async () => {
    if (isDeleting) return
    setIsDeleting(true)
    const result = await DeleteSession(id);
    if (result?.status === 200) {
      toast.success(result.data.message);
      navigate("/coaching");
      dispatch(AllSessionList(SelectedFacility));
    }
    if (result?.response?.status) {
      toast.error(result.response.data.message);
    }
    setIsDeleting(false)
    setArchive(false);
  };
  return (
    <ModalComp
      archive={archive}
      setArchive={setArchive}
      handleDelete={handleDelete}
      isDeleting={isDeleting}
    />
  );
};

export { ArchiveSession };
